import { render } from "./ClienteCreate.vue?vue&type=template&id=703a7503&scoped=true"
import script from "./ClienteCreate.vue?vue&type=script&lang=js"
export * from "./ClienteCreate.vue?vue&type=script&lang=js"

import "./ClienteCreate.vue?vue&type=style&index=0&id=703a7503&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703a7503"]])

export default __exports__